// Wartość atrybutu HTML `sizes` dla obrazów wypełniających kontener strony.
// Przeglądarka nie rozwija zmiennych CSS w atrybucie `sizes`, więc wartość jest
// budowana tutaj, z tych samych map co --arti-generated-img-sizes
// w _common_/assets/css/--break-points-system.scss — przy zmianie map zmień oba miejsca.

const BREAKPOINTS = {
    sm: 480,
    md: 641,
    tablet: 769,
    xl: 1201,
    xxl: 1536,
} as const;

const CONTAINER_MAX_WIDTHS = {
    sm: 440,
    md: 600,
    tablet: 864,
    xl: 1080,
    xxl: 1296,
} as const;

export const CONTAINER_IMG_SIZES = [
    `(max-width: ${BREAKPOINTS.sm - 1}px) 100vw`,
    `(max-width: ${BREAKPOINTS.md - 1}px) ${CONTAINER_MAX_WIDTHS.sm}px`,
    `(max-width: ${BREAKPOINTS.tablet - 1}px) ${CONTAINER_MAX_WIDTHS.md}px`,
    `(max-width: ${BREAKPOINTS.xl - 1}px) ${CONTAINER_MAX_WIDTHS.tablet}px`,
    `(max-width: ${BREAKPOINTS.xxl - 1}px) ${CONTAINER_MAX_WIDTHS.xl}px`,
    `${CONTAINER_MAX_WIDTHS.xxl}px`,
].join(', ');
